export enum ACTIONS {
  CHANGE_ROUND_STATUS = 'CHANGE_ROUND_STATUS',
}

export interface IRoundStatus {
  roundStatus: string | null;
}
